import {
  ClientType,
  ConfigurationDto,
  CurrentClientDto,
  SubscriptionType,
} from "ips/ac/model/api/WinDoFlow.api.types";
import Util from "ips/ac/util/Util";
import { ClientConfigurationType } from "ips/ac/model/odata/generated/IpsCoreModel";

export default class Client {
  private guid: string;
  private hasDataProtection: boolean;
  private hasFlowSubscription: boolean;
  private type: string;
  private subscriptions: SubscriptionType[];
  private configurations: ConfigurationDto[];
  private modules: string[];

  constructor(client: CurrentClientDto) {
    this.guid = client.guid;
    this.hasDataProtection = client.hasDataProtection;
    this.hasFlowSubscription = client.hasFlowSubscription;
    this.type = client.type;
    this.subscriptions = client.subscriptions ?? [];
    this.configurations = client.configurations ?? [];
    this.modules = client.modules ?? [];
  }

  public getGuid(): string {
    return this.guid;
  }

  public isSystemProvider(): boolean {
    return this.type === ClientType.SYSTEM_PROVIDER;
  }

  public getClientPath(): string {
    return `/Clients('${this.getGuid()}')`;
  }

  public hasSubscription(subscription: SubscriptionType): boolean {
    return this.subscriptions.includes(subscription);
  }

  public getConfigurationValue(systemId: ClientConfigurationType): string | undefined {
    return this.configurations.find((config) => config.systemId === systemId)?.value;
  }

  public syncAppModel(): void {
    const appModel = Util.getComponent().getAppModel();

    const clientObject = {
      Guid: this.guid,
      HasDataProtection: this.hasDataProtection,
      HasFlowSubscription: this.hasFlowSubscription,
      Type_Value: this.type,
    };
    Object.defineProperty(clientObject, "isSystemProvider", { get: () => this.isSystemProvider() });

    // set Client last (also after setting user) - otherwise error in processMissingFilesDialog()
    appModel.setProperty("/Client", clientObject);

    const modulePermissions: Record<string, { VIEW: boolean }> = Object.fromEntries(
      this.modules.map((module) => [module, { VIEW: true }] as const),
    );
    appModel.setProperty("/AclClientModulePermissions", modulePermissions);
  }
}